// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1lbRu","content":"RecentSearches_content__22P31"};